<template>
  <v-container my-5>
    <p class="desktop-h1 text-xs-center mb-3">Sign into your Clever account to continue.</p>
    <p class="desktop-h1 text-xs-center">
      <a href="https://clever.com/oauth/authorize?response_type=code&redirect_uri=https%3A%2F%2Fclever.brainingcamp.com%2Foauth&client_id=c66dd90a22561ffb3851">
        <img src="@/assets/login-with-clever@2x.png">
      </a>
    </p>
  </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>

